import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

import { getQueryParamMap, updateQueryString } from '../../../utils';

import { VpHoverInfo } from '../VpHoverInfo';
import { VpIcon } from '../';
import { VpTagInput } from '../../inputs';

const tagInputStyle = {
  width: '100%',
  '& .MuiInputLabel-root': {
    fontSize: '12px !important'
  }
};
const iconStyles = {
  width: '16px',
  height: '16px'
};

const OrLogicFilter = (props) => (
  <Paper {...props}>
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      boxSizing="border-box"
      p="16px 16px 0 16px"
    >
      <Typography variant="caption">OR LOGIC ONLY</Typography>
      <VpHoverInfo label="When multiple types are selected, results will filter for submissions that meet either options.">
        <VpIcon icon="Info" sx={iconStyles} />
      </VpHoverInfo>
    </Stack>
    {/* eslint-disable-next-line react/prop-types */}
    {props?.children}
  </Paper>
);

export const VpFilterSelect = withRouter(
  ({
    history,
    queryKey,
    placeholder,
    data,
    optionValueKey = 'id',
    optionLabelKey = 'name',
    ...rest
  }) => {
    const [tags, setTags] = useState([]);

    const paramMap = getQueryParamMap(history)?.[queryKey]?.split(',');
    const paramTags = data?.filter((tag) => paramMap?.includes(tag[optionValueKey])) || [];

    useEffect(() => {
      setTags(paramTags);
    }, [data]);

    const onChange = (value) => {
      setTags(value);

      const queryValues = value.map((tag) => tag[optionValueKey]).join(',');
      updateQueryString(history, { [queryKey]: queryValues?.length ? queryValues : undefined });
    };

    return (
      <VpTagInput
        options={data || []}
        value={tags}
        onChange={onChange}
        placeholder={placeholder}
        freeSolo={false}
        sx={tagInputStyle}
        PaperComponent={OrLogicFilter}
        hideHelperText
        optionValueKey={optionValueKey}
        optionLabelKey={optionLabelKey}
        {...rest}
      />
    );
  }
);

export default VpFilterSelect;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpFilterSelect/VpFilterSelect.jsx